module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-laugh-2-svgrepo-com.0b26f534.svg";